module.exports = __webpack_public_path__ + "static/media/tpn-ce-2.4a9616a9.jpg";